import * as React from "react";

type Size = "xs" | "sm" | "md";

export function QMono({
  size = "sm",
  caps = false,
  children,
  className,
}: {
  size?: Size;
  caps?: boolean;
  children: React.ReactNode;
  className?: string;
}) {
  const cls = ["qv3-mono-hud", `size-${size}`, caps && "is-caps", className]
    .filter(Boolean)
    .join(" ");
  return <span className={cls}>{children}</span>;
}
